import { useEffect, useRef, useState } from 'react';
import { Button, CarouselGridWrapper, Col, Row } from '@salutejs/plasma-ui';
import { useNavigate } from 'react-router-dom';
import { useGetPostCardsQuery } from '@/graphql/graphQlApiHooks';
import { useMain } from '@/store/main';

const HelpSliderComponentDesktop = () => {
  const [image, setImage] = useState<string>('images/gallery/01.jpg');
  const focusButtonHowWorkRef = useRef<HTMLButtonElement>(null);

  const navigate = useNavigate();
  const { data, loading } = useGetPostCardsQuery({
    variables: {
      input: { skip: 0, limit: 2, isMy: true }
    },
    fetchPolicy: 'cache-and-network'
  });

  const { showHelpSliderComponent, setHideForShowHelpSliderComponent } = useMain((state) => ({
    setHideForShowHelpSliderComponent: state.setHideForShowHelpSliderComponent,
    showHelpSliderComponent: state.showHelpSliderComponent
  }));

  const handleClick = () => {
    setHideForShowHelpSliderComponent();
    navigate('/generate');
  };

  const openHelp = () => {
    navigate('/help');
  };

  useEffect(() => {
    let image = 1;
    setInterval(() => {
      image += 1;
      if (image === 4) image = 1;
      setImage(`images/gallery/0${image}.jpg`);
    }, 10 * 1000);
  }, []);

  useEffect(() => {
    focusButtonHowWorkRef?.current?.focus();
  }, []);

  if (loading || data?.getPostCards.length || !showHelpSliderComponent) return;

  return (
    <div style={{ position: 'fixed', top: 0, zIndex: 8, width: 'calc(100vw - 40px)', left: 0 }}>
      <CarouselGridWrapper style={{ borderRadius: '24px 24px 0 0' }}>
        <Row>
          <Col size={12}>
            <div
              style={{
                background: `linear-gradient(rgba(37, 37, 37, 0) 0%, rgba(37, 37, 37, 0.01) 8.07%, rgba(37, 37, 37, 0.02) 15.54%, rgba(37, 37, 37, 0.05) 22.5%, rgba(37, 37, 37, 0.08) 29.04%, rgba(37, 37, 37, 0.13) 35.26%, rgba(37, 37, 37, 0.18) 41.25%, rgba(37, 37, 37, 0.25) 47.1%, rgba(37, 37, 37, 0.32) 52.9%, rgba(37, 37, 37, 0.4) 58.75%, rgba(37, 37, 37, 0.48) 64.74%, rgba(37, 37, 37, 0.58) 70.96%, rgba(37, 37, 37, 0.67) 77.5%, rgba(37, 37, 37, 0.78) 84.46%, rgba(37, 37, 37, 0.89) 91.93%, #252525 100%),
                  url(${image}) center center / cover no-repeat, lightgray`,
                height: 'calc(100vh - 40px)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'end',
                alignItems: 'center',
                color: 'white',
                textAlign: 'center',
                padding: '20px'
              }}
            >
              <p
                style={{
                  fontSize: '1.7vw',
                  fontStyle: 'normal',
                  fontWeight: 700,
                  lineHeight: 'calc(1.4vw* 2)'
                }}
              >
                Присоединяйтесь к глобальному движению. <br />
                Раскройте свой творческий <br />
                потенциал
              </p>
              <Button
                scaleOnInteraction={false}
                text={'Создать'}
                onClick={handleClick}
                view={'checked'}
                size="s"
                style={{
                  width: '20vw',
                  opacity: 1,
                  marginBottom: '12px',
                  fontSize: '1.4vw',
                  height: 'calc(1.4vw* 2)',
                  lineHeight: 'calc(1.4vw* 2)'
                }}
              />
              <Button
                ref={focusButtonHowWorkRef}
                scaleOnInteraction={false}
                text={'Как это работает?'}
                onClick={openHelp}
                size="s"
                style={{
                  width: '20vw',
                  opacity: 1,
                  fontSize: '1.4vw',
                  height: 'calc(1.4vw* 2)',
                  lineHeight: 'calc(1.4vw* 2)'
                }}
              />
              <span
                onClick={openHelp}
                style={{
                  marginTop: '24px',
                  paddingBottom: '100px'
                }}
              ></span>
            </div>
          </Col>
        </Row>
      </CarouselGridWrapper>
    </div>
  );
};

export default HelpSliderComponentDesktop;
